import { CarData, CarViewSettings } from 'application/api'
import { getProjectName } from 'lib/get-project-name'
import { usePriceFormatter } from 'lib/use-price-formatter'
import { FC } from 'react'
import styled from 'styled-components'

type Props = {
  carData: CarData
  carViewSettings: CarViewSettings
}

export const AdditionalEquipment: FC<Props> = ({ carData, carViewSettings }) => {
  const formatPrice = usePriceFormatter()

  if (carData.additionalEquipmentCost === null || carData.additionalEquipmentCost <= 0) return null

  return (
    <Wrapper>
      <AdditionalEquipmentText>{carViewSettings?.i18n?.additionalEquipmentPrice}</AdditionalEquipmentText>
      <AdditionalEquipmentPrice>+{formatPrice(carData.additionalEquipmentCost)}</AdditionalEquipmentPrice>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  margin-top: -1.5rem;
`

const AdditionalEquipmentPrice = styled.p`
  margin-top: 0;
  ${({ theme }) => theme.textStyles.p2};
  color: ${({ theme }) => theme.palette.black};
  font-weight: 700;
`

const AdditionalEquipmentText = styled.p`
  margin: 0;
  ${({ theme }) => theme.textStyles.p2};
  color: ${({ theme }) => theme.palette.grey[900]};
`
